<template>
  <v-dialog
    v-on="$listeners"
    v-bind="$attrs"
    @click:outside="close"
    width="400"
  >
    <v-card>
      <v-card-title>
        {{ $t("help-center.insert-password-to-edit") }}
      </v-card-title>

      <v-card-text class="mt-4">
        <v-form ref="form" @submit.prevent="handleSubmit">
          <v-row>
            <v-col cols="12">
              <BaseTextField
                v-model="password"
                :rules="[rules.required]"
                :label="$t('help-center.password')"
                :placeholder="$t('help-center.insert-password')"
                type="password"
                autocomplete="off"
              />
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                @click="close"
                class="mr-2"
                outlined
                rounded
                color="fourth"
              >
                {{ $t("common.cancel") }}
              </v-btn>
              <BaseButton
                :loading="loadingValidateUserPassword"
                variant="filter"
                type="submit"
              >
                {{ $t("help-center.validate") }}
              </BaseButton>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import formRules from "../../mixins/formRules";
import BaseTextField from "../forms/BaseTextField.vue";
import BaseButton from "../forms/BaseButton.vue";

export default {
  name: "ValidatePasswordModal",
  mixins: [formRules],
  components: {
    BaseTextField,
    BaseButton,
  },
  data() {
    return {
      password: "",
    };
  },
  computed: {
    ...mapGetters(["loadingValidateUserPassword", "isValidUserPassword"]),
  },
  methods: {
    ...mapActions(["validateUserPassword"]),
    close() {
      this.$refs.form.reset();
      this.$emit("close");
    },
    async handleSubmit() {
      if (!this.$refs.form.validate()) return;

      await this.validateUserPassword(this.password);

      if (this.isValidUserPassword) {
        this.$emit("success");
        this.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
